/**
 * @file settings.ts
 * @module api/apiJSON/settings
 * @description Defines settings API request configuration and payload helpers.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { IListAppSettings } from '../../types/request_data/settings';
export const settingsJSON = {
  appData: ({ interfaceName ,warehouse}: IListAppSettings) => {
    let data: any = {};
    if (interfaceName) {
      data = { ...data, interface: interfaceName };
    }
    if(warehouse){
      data.warehouse = warehouse
    }
    return data;
  },
};
